import { ParentWorkItemContext, ProjectContext, StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum, UserProfile, WorkItemComment } from "./clients/ogg";

export interface IManifest {
  version?: string;
  oggConfig?: IOggConfig;
}

export interface IOggConfig {
  projectContext: ProjectContext
  oggApiUrl: string
}

export interface Suggestion {
  workItemTitle?: string;
  workItemDescription?: string;
  workItemAcceptanceCriteria?: string;
}

export interface IWorkItemManager {
  getId(): Promise<string>;

  getTitleField(): Promise<string>;
  getDescriptionField(): Promise<string>;
  getAcceptanceCriteriaField(): Promise<string>;
  getParentWorkItem(): Promise<ParentWorkItemContext>;
  getComments(): Promise<WorkItemComment[]>;
  getMeetingTranscription(): Promise<string>;
  // a null workItemId will give you the url of the current work item
  getUrl(workItemId?: string): Promise<string>;

  setTitleField(value: string): Promise<void>;
  setDescriptionField(value: string): Promise<void>;
  setAcceptanceCriteriaField(value: string): Promise<void>;

  saveRating(rating: Rating): Promise<void>;
  openWorkItemCreateForm(type: string, initialValues?: {
    [fieldName: string]: Object;
  }): Promise<string | null>;
  openWorkItem(workItemId: string): Promise<void>;
}

export interface IAuthenticationProvider {
  getBearerToken(): Promise<string>;
  getUserEmail(): Promise<string>;
  accessTokenType: StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum
}

export interface IToastProvider {
  showToast(message: string, duration: number): Promise<void>;
}

export interface IProjectContextProvider {
  getProjectContext(): Promise<ProjectContext>
  setProjectContext(value: ProjectContext): Promise<void>
}

export const writingStyles = [
  { id: 'default', text: 'Default' },
  { id: 'baby', text: 'Baby Voice' },
  { id: 'arnold', text: 'Arnold Schwarzenegger' },
  { id: 'austin_powers', text: 'Austin Powers' },
  { id: 'demandalot', text: 'Lord Demandalot' },
  { id: 'nancy', text: 'Nancy' },
];

export type DefinitionOfReadyCriteria = string;
export type DefinitionOfReady = Array<DefinitionOfReadyCriteria>;

export interface Rating {
  detail?: number,
  businessCase?: number,
  reasoning?: number,
  flow?: number,
  calculations?: number,
  userGroups?: number,
  terms?: number
}

export interface IProfileService {
  getProfile(): Promise<UserProfile>;
}

export interface IProposedWorkItem {
  type: "userstory" | "feature"
  title: string
  description: string
  acceptanceCriteria: string
  status?: "Proposed" | "Created"
  workItemId?: string
}